// @needs-native-review — best-effort translation
import type { ChromeTranslations } from '../types';

export const bn: ChromeTranslations = {
  'nav.nextPage': 'পরের পৃষ্ঠা →',
  'nav.previousPage': '← আগের পৃষ্ঠা',
  'nav.continueToLevel': 'লেভেলে চলো →',
  'nav.backToMenu': 'মেনুতে ফিরে যাও →',
  'howto.page': '{total}-এর মধ্যে পৃষ্ঠা {n}',
  'options.title': 'বিকল্প',
  'ui.language': 'ভাষা',
};
